import React from 'react';
import TaskList from './components/TaskList/TaskList';

function App() {
  return (
    <div>
      <TaskList />
    </div>
  );
}

export default App;
